import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//

import * as stepperComponents from '~/components/stepper';
import progressMovil from '~/components/progress-movil';
import mobileRankingTable from '~/components/shared/ranking-mobile-table';
import mobileAffiliationsTable from '~/components/shared/affiliations-mobile-table';
import mobileWorkedTable from '~/components/shared/worked-mobile-table';
import { SaveAfiliation, NotAffiliationFinalized } from '~/components/modals';
export default {
    layout: 'stepped',
    components: _extends({}, stepperComponents, {
        progressMovil: progressMovil,
        SaveAfiliation: SaveAfiliation,
        NotAffiliationFinalized: NotAffiliationFinalized,
        mobileRankingTable: mobileRankingTable,
        mobileAffiliationsTable: mobileAffiliationsTable,
        mobileWorkedTable: mobileWorkedTable
    }),
    data: function data() {
        return {
            page: 1,
            pageSize: 50,
            steps: this.step
        };
    },

    computed: {
        isMovil: function isMovil() {
            return this.$vuetify.breakpoint.name == 'md' || this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs';
        }
    },
    methods: {
        appendList2Data: function appendList2Data() {
            var _this = this;

            if (this.loading) {
                return;
            }
            this.loading = true;
            setTimeout(function () {
                if (_this.page === 5) {
                    _this.text = '';
                    _this.list2.push('No more data');
                    _this.loading = false;
                    return;
                }
                _this.sellers = _this.sellers.concat(_this.list2);
                _this.page++;
                _this.loading = false;
            }, 2000);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            _this2.getList2Data();
        }, 2000);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ranking-detail.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ranking-detail.vue
// module chunks = 1